import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { ModificationDto, ShortProjectDto } from "app/ApiClient";
import { EncodingVersionDto } from "app/SharedApiClient";

export type NormalizedShortProject = ShortProjectDto & {
  upperOriginProjectId: string;
  upperProjectName: string;
};
export interface ProjectSelectorState {
  projects: NormalizedShortProject[];
  versions: EncodingVersionDto[];
  modifications: ModificationDto[];
  loading: LoadingState;
  versionsLoading: LoadingState;
  modificationsLoading: LoadingState;
}
export const initialProjectSelectorState: ProjectSelectorState = {
  loading: LoadingState.idle,
  projects: [],
  versions: [],
  versionsLoading: LoadingState.idle,
  modificationsLoading: LoadingState.idle,
  modifications: [],
};
